import { useState } from 'react';
import { Modal } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { UsersHorizontalScrollCard } from 'features/users/components';
import { useOrganizationAdminsInfiniteQuery } from '../../queries';
import { OrganizationAdminsList } from './organization-admins-list';

type P = {
  organizationId: string;
};

const OrganizationAdminsCard = ({ organizationId }: P) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: administrators, isLoading } = useOrganizationAdminsInfiniteQuery({
    filter: { organizationId },
    pagination: { pageSize: 10 },
  });

  const allAdministrators = administrators?.pages[0]?.data ?? [];
  const allAdministratorsTotal = administrators?.pages[0]?.total ?? 0;

  if (!isLoading && (!allAdministratorsTotal || allAdministrators.length === 0)) {
    return null;
  }

  return (
    <>
      <UsersHorizontalScrollCard
        isLoading={isLoading}
        onClick={() => {
          setIsModalOpen(true);
        }}
        title="Admins"
        users={allAdministrators}
        usersTotal={allAdministratorsTotal}
      />

      <Modal
        isOpened={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        title="Admins"
      >
        <Modal.ScrollableContent>
          <OrganizationAdminsList organizationId={organizationId} />
        </Modal.ScrollableContent>
      </Modal>
    </>
  );
};

export default OrganizationAdminsCard;
